"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stripTrailingSlash = void 0;
const stripTrailingSlash = (str) => str.replace(/\/$/, "");
exports.stripTrailingSlash = stripTrailingSlash;
